import type { SharedWithMeDrawing } from "../data/api";

import "./DrawingsDashboard.scss";

interface SharedDrawingCardProps {
  drawing: SharedWithMeDrawing;
  /** Abre o desenho original em modo somente-leitura. */
  onOpen: (id: string) => void;
  /** Cria uma cópia editável (fork) e a abre. */
  onSaveCopy: (id: string) => void;
}

// Card da seção "Compartilhados comigo". Reaproveita o visual de `.drawing-card`,
// mas sem as ações de dono (renomear/excluir/mover/tags) — o usuário não é dono.
export const SharedDrawingCard = ({
  drawing,
  onOpen,
  onSaveCopy,
}: SharedDrawingCardProps) => {
  const { id, name, thumbnail, permission, message, owner_name, owner_email } =
    drawing;
  const ownerLabel = owner_name || owner_email;
  const canEdit = permission === "edit";

  return (
    <div
      className="drawing-card drawing-card--shared"
      onDoubleClick={() => onOpen(id)}
      title="Abrir em modo leitura"
    >
      <div className="drawing-card__cover">
        {thumbnail ? (
          <img
            className="drawing-card__cover-img"
            src={thumbnail}
            alt={name}
            draggable={false}
          />
        ) : (
          <div className="drawing-card__cover-placeholder">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <path d="M3 14l5-5 4 4 3-3 6 6" />
              <circle cx="8.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
            </svg>
          </div>
        )}
      </div>

      <div className="drawing-card__info">
        <span className="drawing-card__name" title={name}>
          {name}
        </span>
        <span
          className="drawing-card__owner"
          title={`Compartilhado por ${ownerLabel}`}
        >
          Compartilhado por {ownerLabel}
        </span>
        {message && (
          <p className="drawing-card__note" title={message}>
            “{message}”
          </p>
        )}
        <div className="drawing-card__shared-row">
          <span
            className={`drawing-card__perm-badge ${
              canEdit ? "drawing-card__perm-badge--edit" : ""
            }`}
          >
            {canEdit ? "Pode editar" : "Somente leitura"}
          </span>
          {canEdit && (
            <button
              type="button"
              className="drawing-card__save-copy"
              onClick={(e) => {
                e.stopPropagation();
                onSaveCopy(id);
              }}
            >
              Salvar cópia
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
